import angular from 'angular';

import 'angular-resource';
import 'angular-local-storage';
import 'angular-translate';
import 'angular-translate-storage-local';
import 'angular-translate-storage-cookie';
import 'angular-translate-loader-static-files';
import 'angular-ui-bootstrap';
import 'ng-infinite-scroll/build/ng-infinite-scroll';
import 'angular-ui-router';
import 'angular-ui-mask';
import 'jquery-ui/ui/widgets/draggable';
import 'jquery-ui/ui/widgets/droppable';
import 'jquery-ui/ui/widgets/sortable';
import 'angular-dragdrop';
import 'angular-cookies';
import 'angular-sanitize';
import 'angular-modal-service';
import 'angular-dynamic-locale';
import 'angular-xeditable';
import 'jquery-minicolors';
import 'angular-minicolors';
import './assets/angularjs-ckeditor';
import 'ng-tags-input';
import 'moment';
import 'angular-moment';
import 'angular-file-saver';
import 'angularjs-autogrow';

import { registerPlugin } from 'react-filepond';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

import components from './components';
import SignalRService from '@/shared/services/SignalRService';
import DocumentService from '@/shared/services/DocumentService';
import { initTranslateService } from '@/shared/services/TranslateService';
import config from '@/config';
import AuthService from '@/shared/services/AuthService';

angular
  .module('cloudX', [
    'commonServices',
    'cxTable',
    'cxInvoicing',
    'cxRelations',
    'cxRegistrations',
    'cxSettings',
    'cxTranslations',
    'cxNotifications',
    'cxTaskflow',

    'ui.router',
    'ui.mask',
    'ui.bootstrap',

    'ngCookies',
    'ngLocale',
    'ngSanitize',
    'ngDragDrop',

    'angularModalService',

    'infinite-scroll',
    'LocalStorageModule',
    'pascalprecht.translate',
    'tmh.dynamicLocale',
    'xeditable',
    'minicolors',
    'ckeditor',
    'ngTagsInput',
    'angularMoment',
    'ngFileSaver',
    'angularjs-autogrow',
    components,
  ])
  .config([
    '$stateProvider',
    '$urlRouterProvider',
    '$urlMatcherFactoryProvider',
    '$locationProvider',
    '$httpProvider',
    '$translateProvider',
    'tmhDynamicLocaleProvider',
    'ipnConfig',
    'uibDatepickerPopupConfig',
    'uibDatepickerConfig',
    'minicolorsProvider',
    'appUrls',
    'buildversion',
    'environment',
    '$qProvider',
    function(
      $stateProvider,
      $urlRouterProvider,
      $urlMatcherFactoryProvider,
      $locationProvider,
      $httpProvider,
      $translateProvider,
      tmhDynamicLocaleProvider,
      ipnConfig,
      uibDatepickerPopupConfig,
      uibDatepickerConfig,
      minicolorsProvider,
      appUrls,
      buildversion,
      environment,
      $qProvider,
    ) {
      //Make routes case insensitive
      $urlMatcherFactoryProvider.caseInsensitive(true);
      //Special encoder/decoder for passing objects in url params
      $urlMatcherFactoryProvider.type('json', {
        encode: val => JSON.stringify(val),
        decode: str => (str ? JSON.parse(str) : null),
        is: val => angular.isObject(val) && !angular.equals({}, val),
        pattern: /^\{.+\}$/,
      });

      // Fix for AngularJS 1.6 - restore previous hash prefix behavior
      // Default in 1.6+ is '!' but we want empty string for backward compatibility
      $locationProvider.hashPrefix('');

      $stateProvider
        //Layouts
        .state('layout_sb', {
          //Layout with sidebar
          abstract: true,
          template: `<div class="sidebar-wrapper">
                        <div class="sidebar" ui-view="sidebar"></div>
                        <div class="gap"></div>
                        <div class="mainview" ui-view></div>
                      </div>`,
          resolve: {
            ready: [
              'optionsSvc',
              function(optionsSvc) {
                return optionsSvc.ready();
              },
            ],
          },
          params: { settingState: 'settings.general' },
        })
        .state('layout_csb', {
          //Layout with collapsable sidebar
          abstract: true,
          template: `<div class="sidebar-wrapper" ng-class="{'sidebar-collapsed':sb.collapsed,'sidebar-loading':sb.loading}">
                        <div class="sidebar" ui-view="sidebar"></div>
                        <div class="gap">
                          <a ng-click="sb.toggleSidebar()"class="sidebar-toggle"><i class="fa " ng-class="sb.collapsed?'fa-chevron-circle-right':'fa-chevron-circle-left'"></i></a>
                        </div>
                        <div class="mainview" ui-view></div>
                      </div>`,
          controller: 'CollapsableSidebarCtrl as sb',
          resolve: {
            ready: [
              'optionsSvc',
              function(optionsSvc) {
                return optionsSvc.ready();
              },
            ],
          },
          params: { settingState: 'settings.general' },
        })
        .state('layout_full', {
          //Full width layout
          abstract: true,
          template: '<div class="col-md-12" ui-view></div>',
          resolve: {
            ready: [
              'optionsSvc',
              function(optionsSvc) {
                return optionsSvc.ready();
              },
            ],
          },
          params: { settingState: 'settings.general' },
        })
        .state('home', {
          url: '/',
          template: '<home-dashboard-container></home-dashboard-container>',
          isReact: true,
          resolve: {
            ready: [
              'optionsSvc',
              function(optionsSvc) {
                return optionsSvc.ready();
              },
            ],
          },
        })
        .state('myProfile', {
          url: '/profile',
          parent: 'layout_csb',
          views: {
            '': {
              template: '<my-profile-container></my-profile-container>',
            },
            sidebar: {
              template:
                '<cx-rel-search-box></cx-rel-search-box><cx-recent-relations-bar></cx-recent-relations-bar>',
            },
          },
          isReact: true,
        })
        .state('accessTokens', {
          url: '/profile/accessTokens',
          parent: 'layout_csb',
          views: {
            '': {
              template: '<access-tokens-container></access-tokens-container>',
            },
            sidebar: {
              template:
                '<cx-rel-search-box></cx-rel-search-box><cx-recent-relations-bar></cx-recent-relations-bar>',
            },
          },
        })
        .state('403', {
          url: '/Errors/403',
          template: require('./authentication/403.html'),
        })
        .state('relations', {
          url: '/relations',
          parent: 'layout_csb',
          abstract: true,
          views: {
            '': {
              template: '<ui-view/>',
            },
            sidebar: {
              template:
                '<cx-rel-search-box></cx-rel-search-box><cx-recent-relations-bar></cx-recent-relations-bar>',
            },
          },
          resolve: {
            security: [
              'checkSecurity',
              '$q',
              (checkSecurity, $q) => {
                if (!checkSecurity('Relation:r')) return $q.reject('Not Authorized');
              },
            ],
          },
        })
        .state('relations.new', {
          url: '/new',
          template: require('./relations/new/relNew.html'),
          controller: 'RelNewCtrl as vm',
          security: 'Relation:c',
        })
        .state('relations.detail', {
          url: '/detail/:relId',
          template: require('./relations/detail/relationFile.html'),
          controller: 'RelationFileCtrl as vm',
          params: {
            relId: null,
            options: null,
            fromRelBindSvc: false,
            gotoField: null,
          },
          reloadOnSearch: true,
        })
        .state('relations.audit', {
          url: '/audit/:relationId',
          views: {
            '@': {
              template:
                '<relation-audit-container relation-id="relationId"></relation-audit-container>',
              controller: [
                '$scope',
                '$stateParams',
                function($scope, $stateParams) {
                  $scope.relationId = $stateParams.relationId;
                },
              ],
            },
          },
          isReact: true,
        })
        .state('relations.overview', {
          url: '?json',
          views: {
            '': {
              template:
                '<relation-overview-container search-params="searchParams"></relation-overview-container>',
              controller: [
                '$scope',
                '$stateParams',
                function($scope, $stateParams) {
                  $scope.searchParams = {};
                  if (!$stateParams) return;
                  const fieldMap = {
                    relationName: 'searchValue',
                    tags: 'withLabels',
                    relationGroups: 'relationGroups',
                    crmTypes: 'crmTypes',
                    peppolStatus: 'peppolStatus',
                    ownCompanies: 'ownCompanies',
                    sendInvoicePeppolReady: 'sendInvoicePeppolReady',
                    responsible: 'responsible',
                    assistant: 'assistant',
                    assistantBackup: 'assistantBackup',
                    associate: 'associate',
                    billingUser: 'billingUser',
                    seniorUser: 'seniorUser',
                    assignedTo: 'assignedTo',
                    type: 'type',
                    countryCode: 'countryCode',
                    vatPeriodicities: 'vatPeriodicities',
                    vatNumberTypes: 'vatNumberTypes',
                    isPeppolRequired: 'isPeppolRequired',
                  };

                  for (const key in fieldMap) {
                    if ($stateParams[key]) {
                      $scope.searchParams = {
                        ...$scope.searchParams,
                        [fieldMap[key]]: $stateParams[key],
                      };
                    }
                  }
                },
              ],
            },
            'sidebar@layout_csb': {
              template: '<cx-recent-relations-bar></cx-recent-relations-bar>',
            },
          },
          params: {
            relationName: null,
            tags: null,
            crmTypes: null,
            peppolStatus: null,
            relationGroups: null,
            ownCompanies: null,
            sendInvoicePeppolReady: null,
            associate: null,
            assistant: null,
            assistantBackup: null,
            responsible: null,
            billingUser: null,
            seniorUser: null,
            assignedTo: null,
            type: null,
            countryCode: null,
            vatPeriodicities: null,
            vatNumberTypes: null,
            isPeppolRequired: null,
            json: { value: null, type: 'json', squash: true },
          },
          transformJsonParam: true,
          isReact: true,
        })
        .state('relations.compliance', {
          url: '/compliance',
          isReact: true,
          template: '<relation-compliancy-container></relation-compliancy-container>',
        })
        .state('relations.invoiceschedules', {
          url: '/invoiceschedules',
          template: '<invoice-stream-container></invoice-stream-container>',
          security: 'InvoiceDraft:r',
          isReact: true,
        })
        .state('relations.taskSchedules', {
          url: '/taskschedules',
          template: '<task-schedule-overview-container></task-schedule-overview-container>',
          security: 'TaskSchedules',
          isReact: true,
        })
        .state('relations.plannedRegistrations', {
          url: '/planned-registrations',
          template:
            '<planned-registration-overview-container></planned-registration-overview-container>',
          isReact: true,
        })
        .state('relations.budget', {
          url: '/budget',
          template: '<budget-overview-container></budget-overview-container>',
          isReact: true,
          security: ['BudgetHours:r', 'BudgetAmounts:r'],
        })
        .state('relations.interactions', {
          url: '/interactions',
          template: '<interaction-overview-container></interaction-overview-container>',
          isReact: true,
        })
        .state('employees', {
          url: '/employees',
          parent: 'layout_csb',
          abstract: true,
          security: 'Users:r',
          views: {
            '': {
              template: '<ui-view/>',
            },
            sidebar: {
              template: '<ng-include src="\'assets/templates/settings/settingMenu.tpl.html\'">',
              controller: 'SettingMenuCtrl as vm',
            },
          },
        })
        .state('employees.new', {
          url: '/new',
          template: require('./employees/new/empNew.html'),
          controller: 'EmpNewCtrl as vm',
          security: 'Users:c',
          params: {
            temporary: false,
          },
        })
        .state('employees.tmp', {
          url: '/tmp',
          template: require('./employees/new/empNew.html'),
          controller: 'EmpNewCtrl as vm',
          security: 'Users:c',
          params: {
            temporary: true,
          },
        })
        .state('employees.detail', {
          url: '/:id',
          template: require('./employees/detail/employeeDetail.html'),
          controller: 'EmployeeDetailCtrl as vm',
          security: 'Users:r',
          resolve: {
            employee: [
              'resourceFactorySvc',
              '$stateParams',
              function(resourceFactorySvc, $stateParams) {
                return resourceFactorySvc.get('employee').get({
                  id: $stateParams.id,
                }).$promise;
              },
            ],
          },
        })
        .state('employees.overview', {
          url: '',
          template: '<employee-overview-container></employee-overview-container>',
          isReact: true,
          security: 'Users:r',
        })
        .state('employees.profiles', {
          url: '/profiles',
          template: '<employee-profile-overview-container></employee-profile-overview-container>',
          isReact: true,
          security: 'CompanyOwn:r',
        })
        .state('employees.profilesOld', {
          url: '/profiles-old',
          template: require('./employees/profiles/employeeProfileOverview.html'),
          controller: 'EmployeeProfileOverviewCtrl as vm',
          security: 'CompanyOwn:r',
        })
        .state('registrations', {
          url: '/registrations',
          parent: 'layout_full',
          abstract: true,
          template: '<ui-view/>',
        })
        .state('registrations.day', {
          url: '',
          template: require('./registrations/regDay.html'),
          controller: 'RegDayCtrl as vm',
          security: 'RegistrationOwn',
        })
        .state('registrations.overview', {
          url: '/overview/*ignore?json', // Previous url was /overview/:period? -> *ignore catches everthing after /overview in case they bookmarked it
          template: require('./registrations/regOverview.html'),
          controller: 'RegOverviewCtrl as vm',
          params: {
            period: null,
            relation: null,
            userId: null, // empty guid to force combo to all
            filters: null,
            finalInvoiceStreamId: null,
            dateFrom: null,
            dateUntil: null,
            invoiceDateFrom: null,
            invoiceDateUntil: null,
            resourceId: null,
            trainingId: null,
            invoiceId: null,
            intraCompanyInvoiceId: null,
            json: { value: null, type: 'json', squash: true },
            ignore: null, // Everything after /overview/ in the url
          },
          transformJsonParam: true,
          security: ['RegistrationOwn', 'RegistrationOthers'],
        })
        .state('registrations.settings', {
          url: '/priceList',
          template: require('./registrations/resources/priceList.html'),
          controller: 'PriceListCtrl as vm',
          security: ['Pricelist:r', 'AbsenceAndCounters:r'],
        })
        .state('registrations.pricegrid', {
          url: '/pricegrid',
          template: '<price-grid-container></price-grid-container>',
          isReact: true,
          security: 'Pricelist',
        })
        .state('invoicing', {
          url: '/invoicing',
          abstract: true,
          parent: 'layout_full',
          template: '<ui-view/>',
        })
        .state('invoicing.overview', {
          url: '?json',
          template: require('./invoicing/overview/invoicingOverview.html'),
          controller: 'InvoicingOverviewCtrl as vm',
          params: {
            relationId: null,
            relation: null,
            invoiceId: null,
            filterType: null,
            dateFrom: null,
            dateUntil: null,
            invoiceStreamId: null,
            period: null,
            showWrittenOffInternally: null,
            json: { value: null, type: 'json', squash: true },
          },
          security: 'InvoiceFinal',
          transformJsonParam: true,
        })
        .state('invoicing.invoiceFromScratch', {
          url: '/wizard/1',
          template: require('./invoicing/wizard/invoiceFromScratch.html'),
          controller: 'InvoiceFromScratchCtrl as vm',
          data: {
            isInvoice: true,
          },
          security: 'FreeInvoiceCreditNote:c',
        })
        .state('invoicing.creditNoteFromScratch', {
          url: '/wizard/4',
          template: require('./invoicing/wizard/invoiceFromScratch.html'),
          controller: 'InvoiceFromScratchCtrl as vm',
          data: {
            isInvoice: false,
          },
          security: 'FreeInvoiceCreditNote:c',
        })
        .state('invoicing.draft', {
          url: '/draft?json',
          template: require('./invoicing/draft/draftInvoiceOverview.html'),
          controller: 'DraftInvoiceOverviewCtrl as vm',
          params: {
            relationId: null,
            relation: null,
            invoiceId: null,
            invoiceStreamId: null,
            json: { value: null, type: 'json', squash: true },
          },
          security: 'InvoiceDraft',
          transformJsonParam: true,
        })
        .state('invoicing.toInvoice', {
          url: '/toInvoice',
          template: '<to-invoice-container search-params="searchParams"></to-invoice-container>',
          params: {
            relationId: null,
            relationName: null,
          },
          isReact: true,
          controller: [
            '$scope',
            '$stateParams',
            function($scope, $stateParams) {
              $scope.searchParams = {};
              if ($stateParams) {
                if ($stateParams.relationId) {
                  $scope.searchParams = {
                    relationId: $stateParams.relationId,
                  };
                }
                if ($stateParams.relationName) {
                  $scope.searchParams = {
                    ...$scope.searchParams,
                    relationName: $stateParams.relationName,
                  };
                }
              }
            },
          ],
          security: 'InvoiceDraft',
        })
        .state('invoicing.intraCompany', {
          url: '/intraCompany',
          template:
            '<intra-company-billing-container search-params="searchParams"></intra-company-billing-container>',
          isReact: true,
          security: 'IntraCompanyInvoice:r',
          feature: 'IntraCompanyBilling',
        })
        .state('invoicing.transactions', {
          url: '/transactions',
          params: {
            relationId: null,
            showTransactions: true,
          },
          template: require('./invoicing/transaction/transactionOverview.html'),
          controller: 'TransactionOverviewCtrl as vm',
          security: 'InvoiceTransactions',
        })
        .state('translate', {
          abstract: true,
          url: '/translate',
          template: require('./translations/translate.html'),
          parent: 'layout_full',
        })
        .state('translate.labels', {
          url: '/labels',
          template: require('./translations/translateLabels.html'),
          controller: 'TranslateLabelsCtrl as vm',
        })
        .state('translate.lists', {
          url: '/lists',
          template: require('./translations/translateLists.html'),
          controller: 'TranslateListsCtrl as vm',
        })
        .state('config', {
          abstract: true,
          url: '/config',
          template: require('./config/config.html'),
          parent: 'layout_full',
        })
        .state('config.sections', {
          url: '/sections',
          template: require('./config/sections/sectionConfig.html'),
          controller: 'SectionConfigCtrl as vm',
        })
        .state('config.fields', {
          url: '/fields',
          template: require('./config/fields/fieldConfig.html'),
          controller: 'FieldConfigCtrl as vm',
        })
        .state('settings', {
          abstract: true,
          url: '/settings',
          parent: 'layout_csb',
          views: {
            '': {
              template: '<ui-view/>',
            },
            sidebar: {
              template: '<ng-include src="\'assets/templates/settings/settingMenu.tpl.html\'">',
              controller: 'SettingMenuCtrl as vm',
            },
          },
        })
        .state('settings.company', {
          url: '/company/?json',
          template: '<company-container></company-container>',
          isReact: true,
          reloadOnSearch: true,
          security: 'CompanyOwn',
          params: {
            companyId: null,
            json: { value: null, type: 'json', squash: true },
          },
          transformJsonParam: true,
        })
        .state('settings.general', {
          url: '/',
          template: '<general-settings-container></general-settings-container>',
          isReact: true,
          reloadOnSearch: true,
          params: {
            companyId: null,
          },
          security: ['Settings:r', 'Users:u'],
        })
        .state('settings.legalEntities', {
          url: '/legalentities/:id?',
          params: {
            id: { value: null, squash: true },
          },
          template: '<legal-entities-container></legal-entities-container>',
          isReact: true,
          security: 'CompanyOwn',
          feature: 'TenantMoore',
        })
        .state('settings.templates', {
          abstract: true,
          url: '/templates',
          template: '<ui-view/>',
          resolve: {
            companyId: [
              'dataCache',
              '$stateParams',
              function(dataCache, $stateParams) {
                return !$stateParams.companyId
                  ? dataCache.getArray('defaultcompany').id
                  : $stateParams.companyId;
              },
            ],
          },
          params: {
            companyId: null,
          },
        })
        .state('settings.templates.new', {
          url: '/new',
          template: require('./settings/editMailTemplateSettings.html'),
          controller: 'EditMailTemplateSettingsCtrl as vm',
          resolve: {
            template: [
              '$q',
              function($q) {
                return $q.when(null);
              },
            ],
          },
          security: 'Settings:c',
        })
        .state('settings.templates.edit', {
          url: '/:templateId',
          template: require('./settings/editMailTemplateSettings.html'),
          controller: 'EditMailTemplateSettingsCtrl as vm',
          resolve: {
            template: [
              'templateHttpSvc',
              '$stateParams',
              function(templateHttpSvc, $stateParams) {
                return templateHttpSvc.getTemplateWithContent($stateParams.templateId);
              },
            ],
          },
          security: 'Settings:r',
        })
        .state('settings.templates.list', {
          url: '',
          template: require('./settings/mailTemplateSettings.html'),
          controller: 'MailTemplateSettingsCtrl as vm',
          security: 'Settings:r',
        })
        .state('settings.interactiontemplatesform', {
          abstract: true,
          url: '/interactiontemplates',
          template: '<ui-view/>',
          resolve: {
            companyId: [
              'dataCache',
              '$stateParams',
              function(dataCache, $stateParams) {
                return !$stateParams.companyId
                  ? dataCache.getArray('defaultcompany').id
                  : $stateParams.companyId;
              },
            ],
            type: [
              '$stateParams',
              function($stateParams) {
                return $stateParams.type;
              },
            ],
          },
          params: {
            companyId: null,
            type: null,
          },
        })
        .state('settings.interactiontemplatesform.new', {
          url: '/new',
          template: require('./settings/editInteractionTemplateSettings.html'),
          controller: 'EditInteractionTemplateSettingsCtrl as vm',
          resolve: {
            template: [
              '$q',
              function($q) {
                return $q.when(null);
              },
            ],
          },
          security: 'Settings:c',
        })
        .state('settings.interactiontemplatesform.edit', {
          url: '/edit/:templateId',
          template: require('./settings/editInteractionTemplateSettings.html'),
          controller: 'EditInteractionTemplateSettingsCtrl as vm',
          resolve: {
            template: [
              'interactionTemplateHttpSvc',
              '$stateParams',
              function(interactionTemplateHttpSvc, $stateParams) {
                return interactionTemplateHttpSvc.getTemplateWithContent($stateParams.templateId);
              },
            ],
          },
          security: 'Settings:r',
        })
        .state('settings.interactiontemplates', {
          url: '/interactiontemplates/:tab',
          template:
            '<interaction-template-settings-container tab="tab"></interaction-template-settings-container>',
          isReact: true,
          params: {
            tab: {
              dynamic: true,
              value: null,
              squash: true,
            },
          },
          controller: [
            '$scope',
            '$stateParams',
            function($scope, $stateParams) {
              $scope.tab = $stateParams.tab || null;
            },
          ],
          security: 'Settings:r',
        })
        .state('settings.invoiceText', {
          url: '/invoiceText',
          template: require('./settings/invoiceTextSettings.html'),
          controller: 'InvoiceTextSettingsCtrl as vm',
          resolve: {
            data: [
              'resourceFactorySvc',
              function(resourceFactorySvc) {
                return resourceFactorySvc.get('invoiceText').get().$promise;
              },
            ],
          },
          security: 'Settings:r',
        })
        .state('settings.invoiceSchedules', {
          url: '/invoiceSchedules/:editScheduleId',
          template:
            '<invoice-schedules-container edit-schedule-id="editScheduleId"></invoice-schedules-container>',
          isReact: true,
          controller: [
            '$scope',
            '$stateParams',
            function($scope, $stateParams) {
              $scope.editScheduleId = $stateParams.editScheduleId || null;
            },
          ],
          params: {
            editScheduleId: { value: null, squash: true },
          },
          security: 'Settings:r',
        })
        .state('settings.workflowConfiguration', {
          url: '/workflow',
          params: { tab: null },
          template: '<workflow-configuration-container></workflow-configuration-container>',
          isReact: true,
          security: 'Settings:r',
        })
        .state('settings.taskTemplates', {
          url: '/taskTemplates',
          template: require('./settings/taskTemplates.html'),
          controller: 'taskTemplatesCtrl as vm',
          security: 'TaskTemplates:r',
        })
        .state('settings.reminder', {
          url: '/reminder',
          template: require('./settings/reminderSettings.html'),
          controller: 'ReminderSettingsCtrl as vm',
          resolve: {
            reminders: [
              'reminderHttpSvc',
              function(reminderHttpSvc) {
                return reminderHttpSvc.getReminders();
              },
            ],
          },
        })
        .state('settings.license', {
          url: '/license',
          template: require('./settings/license.html'),
          controller: 'licenseCtrl as vm',
          security: ['CompanyOwn:u', 'Support'],
        })
        .state('settings.folderStructure', {
          url: '/folders',
          template: '<document-tree-configuration></document-tree-configuration>',
          isReact: true,
          security: 'Settings:r',
        })
        .state('settings.tags', {
          url: '/Tags/:tab',
          template: '<tag-settings-container tab="tab"></tag-settings-container>',
          isReact: true,
          params: {
            tab: {
              dynamic: true,
              value: null,
              squash: true,
            },
          },
          controller: [
            '$scope',
            '$stateParams',
            function($scope, $stateParams) {
              $scope.tab = $stateParams.tab || null;
            },
          ],
          security: 'Tags:r',
        })
        .state('settings.teams', {
          url: '/teams',
          template: '<teams-container></teams-container>',
          isReact: true,
          security: 'Teams:r',
        })
        .state('settings.documentTemplates', {
          url: '/DocumentTemplates',
          template: '<document-template-container></document-template-container>',
          isReact: true,
          security: 'Settings:r',
        })
        .state('settings.assignmentTemplates', {
          url: '/AssignmentTemplates',
          template: '<assignment-template-container></assignment-template-container>',
          isReact: true,
          security: 'Settings:r',
        })
        .state('settings.roles', {
          url: '/Roles',
          template: '<tenant-role-container></tenant-role-container>',
          isReact: true,
          security: 'CompanyOwn:r',
        })

        .state('taskflow', { abstract: true })
        .state('taskflow.taskboard', {
          url: '/taskboard/:plannedTaskId?json',
          views: {
            '@': {
              template: `<taskboard-container relation="relation"
                                              invoice-stream-id="invoiceStreamId"
                                              task-template-id="taskTemplateId"
                                              planned-task-id="plannedTaskId"
                                              kpi="kpi"
                                              user-id="userId"
                                              only-subtasks-for-assigned-user="onlySubtasksForAssignedUser"
                                              user-is-next-assigned-user="userIsNextAssignedUser"
                                              open-planned-task-detail-modal="openPlannedTaskDetailModal"
                                              deadline-from="deadlineFrom"
                                              deadline-until="deadlineUntil"
                                              create-task-for-relation="createTaskForRelation">
                          </taskboard-container>`,
              controller: [
                '$scope',
                '$stateParams',
                function($scope, $stateParams) {
                  $scope.relation = $stateParams.relation;
                  $scope.invoiceStreamId = $stateParams.invoiceStreamId;
                  $scope.taskTemplateId = $stateParams.taskTemplateId;
                  $scope.plannedTaskId = $stateParams.plannedTaskId;
                  $scope.kpi = $stateParams.kpi;
                  $scope.userId = $stateParams.userId;
                  $scope.onlySubtasksForAssignedUser = $stateParams.onlySubtasksForAssignedUser;
                  $scope.userIsNextAssignedUser = $stateParams.userIsNextAssignedUser;
                  $scope.openPlannedTaskDetailModal = $stateParams.openPlannedTaskDetailModal;
                  $scope.deadlineFrom = $stateParams.deadlineFrom;
                  $scope.deadlineUntil = $stateParams.deadlineUntil;
                  $scope.createTaskForRelation = $stateParams.createTaskForRelation;
                },
              ],
            },
          },
          params: {
            invoiceStreamId: null,
            relation: null,
            taskTemplateId: null,
            plannedTaskId: null,
            kpi: null,
            userId: null,
            onlySubtasksForAssignedUser: null,
            userIsNextAssignedUser: null,
            openPlannedTaskDetailModal: true,
            deadlineFrom: null,
            deadlineUntil: null,
            createTaskForRelation: null,
            json: { value: null, type: 'json', squash: true },
            //Also add params to emptyState var in getFiltersFromRouteOrLocalStorage in TaskboardContainer
          },
          isReact: true,
          transformJsonParam: true,
          security: 'PlannedTask',
        })
        .state('taskflow.overview', {
          url: '/taskoverview',
          controllerAs: 'vm',
          template:
            '<task-overview-container search-params="searchParams"></task-overview-container>',
          params: {
            filters: null,
          },
          isReact: true,
          controller: [
            '$scope',
            '$stateParams',
            function($scope, $stateParams) {
              $scope.searchParams = {};
              if ($stateParams && $stateParams.filters) {
                $scope.searchParams = $stateParams.filters;
              }
            },
          ],
          security: 'PlannedTask',
        })
        .state('taskflow.progressPerEmployee', {
          url: '/taskprogressperemployee',
          template:
            '<task-progress-per-employee-container search-params="searchParams"></task-progress-per-employee-container>',
          params: {
            filters: null,
          },
          isReact: true,
          controller: [
            '$scope',
            '$stateParams',
            function($scope, $stateParams) {
              $scope.searchParams = {};
              if ($stateParams && $stateParams.filters) {
                $scope.searchParams = $stateParams.filters;
              }
            },
          ],
          security: 'PlannedTask',
        })
        .state('taskflow.tasklist', {
          url: '/tasklist/:taskId?json',
          template:
            '<task-list-container sort="sort" desc="desc" search-params="searchParams" task-id="taskId"></task-list-container>',
          params: {
            filters: null,
            taskId: null,
            sort: null,
            desc: null,
            json: { value: null, type: 'json', squash: true },
          },
          isReact: true,
          transformJsonParam: true,
          controller: [
            '$scope',
            '$stateParams',
            function($scope, $stateParams) {
              $scope.searchParams = {};
              if ($stateParams && $stateParams.filters) {
                $scope.searchParams = { filters: $stateParams.filters };
              }
              $scope.taskId = $stateParams.taskId;
              $scope.sort = $stateParams.sort;
              $scope.desc = $stateParams.desc;
            },
          ],
          security: ['PlannedTask', 'Todo'],
        })
        .state('taskflow.dashboard', {
          url: '/taskdashboard',
          template: '<task-dashboard-container></task-dashboard-container>',
          isReact: true,
          security: 'PlannedTask',
        })

        .state('documents', {
          url: '/documents/:documentId?json',
          template:
            '<documents-container search-params="searchParams" document-id="documentId"></documents-container>',
          params: {
            relationId: null,
            relationName: null,
            companyId: null,
            tags: '' /* Should be string, tags separated by ;  */,
            documentId: null,
            json: { value: null, type: 'json', squash: true },
          },
          isReact: true,
          transformJsonParam: true,
          controller: [
            '$scope',
            '$stateParams',
            function($scope, $stateParams) {
              $scope.searchParams = {};
              $scope.documentId = $stateParams.documentId;
              if ($stateParams) {
                if ($stateParams.tags) {
                  $scope.searchParams.mainFilters = $scope.searchParams.mainFilters || {};
                  $scope.searchParams.tags = $stateParams.tags;
                  $scope.searchParams.filter = {};
                }
                if ($stateParams.relationId) {
                  $scope.searchParams.mainFilters = $scope.searchParams.mainFilters || {};
                  $scope.searchParams.mainFilters.relationId = $stateParams.relationId;
                  if ($stateParams.relationName) {
                    $scope.searchParams.mainFilters.relationName = $stateParams.relationName;
                  }
                  if ($stateParams.companyId) {
                    // Used for global actions, not the own company filter
                    $scope.searchParams.mainFilters.companyId = $stateParams.companyId;
                  }
                  $scope.searchParams.filter = {};
                }
              }
            },
          ],
          security: 'Documents:r',
        })
        .state('documents.relation', {
          url: 'relation/:relationId',
          redirectTo: trans => ({
            state: 'documents',
            params: trans.params(),
          }),
          params: {
            relationId: null,
          },
          security: 'Documents:r',
        })
        .state('emails', {
          url: '/emails',
          template: '<emails-container></emails-container>',
          isReact: true,
          security: 'Documents:r',
        })
        .state('settings.invoicetemplates', {
          url: '/invoicetemplates',
          template: require('./settings/invoiceTemplates.html'),
          controller: 'InvoiceTemplatesCtrl as vm',
        })
        .state('jobs', {
          url: '/jobs',
          abstract: true,
        })
        .state('jobs.overview', {
          url: '/',
          template: '<job-overview-container></job-overview-container>',
          isReact: true,
        })
        .state('jobs.detail', {
          url: '/:jobId',
          template: '<job-detail-container job-id="jobId"></job-detail-container>',
          isReact: true,
          controller: [
            '$scope',
            '$stateParams',
            function($scope, $stateParams) {
              $scope.jobId = $stateParams.jobId;
            },
          ],
        })
        .state('reports', {
          url: '/reports',
          abstract: true,
        })
        .state('reports.relationRentability', {
          url: '/relation-rentabiltity',
          template:
            '<relation-rentability-container search-params="searchParams"></relation-rentability-container>',
          params: {
            relationId: null,
          },

          isReact: true,
          controller: [
            '$scope',
            '$stateParams',
            function($scope, $stateParams) {
              if ($stateParams.relationId) {
                $scope.searchParams = { relationId: $stateParams };
              } else {
                $scope.searchParams = {};
              }
            },
          ],
          security: 'RentabilityReport:r',
        })
        .state('reports.hoursPerEmployee', {
          url: '/hours-per-employee',
          redirectTo: 'hrm.hoursPerEmployee',
          security: 'RegistrationOwn:r',
        })
        .state('reports.invoicingHistory', {
          url: '/invoicing-history',
          template:
            '<invoicing-history-container search-params="searchParams"></invoicing-history-container>',
          isReact: true,
          security: 'ChecklistInvoicingReport:r',
        })
        .state('reports.performanceBalance', {
          url: '/performance-balance',
          template: '<performance-balance-container></performance-balance-container>',
          isReact: true,
          security: 'RentabilityReport:r',
        })
        .state('reports.registrationsPerRelation', {
          url: '/registrations-per-relation',
          template:
            '<registrations-per-relation-container search-params="searchParams"></registrations-per-relation-container>',
          isReact: true,
          security: 'RegistrationsPerReports:r',
        })
        .state('reports.registrationsPerResourceCategory', {
          url: '/registrations-per-resource-category',
          template:
            '<registrations-per-resource-category-container search-params="searchParams"></registrations-per-resource-category-container>',
          isReact: true,
          security: 'RegistrationsPerReports:r',
        })
        .state('reports.registrationsPerTaskTemplate', {
          url: '/registrations-per-task-template',
          template:
            '<registrations-per-task-template-container search-params="searchParams"></registrations-per-task-template-container>',
          isReact: true,
          security: 'RegistrationsPerReports:r',
        })
        .state('reports.registrationsPerUser', {
          url: '/registrations-per-user',
          template:
            '<registrations-per-user-container search-params="searchParams"></registrations-per-user-container>',
          isReact: true,
          security: 'RegistrationsPerReports:r',
        })
        .state('reports.absencePerEmployee', {
          url: '/absences',
          redirectTo: 'hrm.absencePerEmployee',
          security: 'AbsenceReports:r',
        })
        .state('interactions', {
          url: '/interactions/:relationId/:interactionId',
          template:
            '<interactions-container search-params="searchParams" open-mail-modal="openMailModal"></interactions-container>',
          params: {
            relationId: null,
            openMailModal: false,
            interactionId: null,
          },
          isReact: true,
          controller: [
            '$scope',
            '$stateParams',
            function($scope, $stateParams) {
              $scope.searchParams = {};
              $scope.openMailModal = false;
              $scope.searchParams.interactionFilters = {};
              if ($stateParams) {
                if ($stateParams.relationId) {
                  $scope.searchParams.interactionFilters = {
                    ...$scope.searchParams.interactionFilters,
                    relationId: $stateParams.relationId,
                  };
                }
                if ($stateParams.interactionId) {
                  $scope.searchParams.interactionFilters = {
                    ...$scope.searchParams.interactionFilters,
                    interactionId: $stateParams.interactionId,
                  };
                }
                if ($stateParams.openMailModal) {
                  $scope.openMailModal = $stateParams.openMailModal;
                }
              }
            },
          ],
          security: 'InteractionsOwn:r',
        })
        .state('notifications', {
          url: '/notifications',
          template:
            '<notification-overview-container search-params="searchParams"></notification-overview-container>',
          isReact: true,
          params: { sharedWithMe: undefined },
          reloadOnSearch: true,
          controller: [
            '$scope',
            '$stateParams',
            function($scope, $stateParams) {
              $scope.searchParams = {};
              if ($stateParams) {
                $scope.searchParams = Object.keys($stateParams).reduce((o, key) => {
                  if (!$stateParams.hasOwnProperty(key)) return o;
                  if (key === '#') return o;
                  if (typeof $stateParams[key] === 'undefined') return o;
                  o[key] = $stateParams[key];
                  return o;
                }, {});
              }
              if (Object.keys($scope.searchParams).length === 0) $scope.searchParams = null;
            },
          ],
        })
        .state('notificationSettings', {
          url: '/NotificationSettings',
          template: '<notification-settings-container></notification-settings-container>',
          isReact: true,
        })
        .state('settings.relationTags', {
          url: '/relations/tags',
          template: '<relation-tag-overview></relation-tag-overview>',
          isReact: true,
          security: 'Tags:r',
        })
        .state('settings.taskTags', {
          url: '/tasks/tags',
          template: '<task-tag-overview></task-tag-overview>',
          isReact: true,
          security: 'Tags:r',
        })
        .state('hrm', {
          url: '/hrm',
          abstract: true,
          parent: 'layout_full',
          template: '<ui-view/>',
        })
        .state('hrm.overview', {
          url: '?json',
          template: '<hrm-overview-container></hrm-overview-container>',
          security: 'AbsenceAndCounters:r',
          isReact: true,
          transformJsonParam: true,
        })
        .state('hrm.hoursPerEmployee', {
          url: '/hours-per-employee',
          security: ['RegistrationOwn:r', 'RegistrationOthers:r'],
          template:
            '<hours-per-employee-report-container search-params="searchParams"></hours-per-employee-report-container>',
          isReact: true,
        })
        .state('hrm.absencePerEmployee', {
          url: '/absences',
          template: '<absence-per-employee-container></absence-per-employee-container>',
          isReact: true,
          security: 'AbsenceReports:r',
        })
        .state('hrm.absenceCalendar', {
          url: '/calendar',
          template: '<absence-calendar-container></absence-calendar-container>',
          isReact: true,
          security: 'AbsenceReports:r',
        })
        .state('trainings', {
          url: '/trainings',
          abstract: true,
          parent: 'layout_full',
          template: '<ui-view/>',
        })
        .state('trainings.overview', {
          url: '/settings',
          template: '<training-overview-container></training-overview-container>',
          security: 'TrainingManagement:r',
          isReact: true,
          transformJsonParam: true,
        })
        .state('trainings.employeeOverview', {
          url: '',
          template: '<training-employee-overview-container></training-employee-overview-container>',
          security: 'RegistrationOwn:r',
          isReact: true,
          transformJsonParam: true,
        })
        .state('assignmentAnalysis', {
          url: '',
          abstract: true,
          parent: 'layout_full',
          template: '<ui-view/>',
        })
        .state('assignmentAnalysis.employeeRelationMatrix', {
          url: '/employee-relation-matrix',
          template:
            '<assignment-analysis-employee-relation-matrix></assignment-analysis-employee-relation-matrix>',
          isReact: true,
        })
        .state('assignmentAnalysis.employeeTaskMatrix', {
          url: '/employee-task-matrix',
          template:
            '<assignment-analysis-employee-task-matrix></assignment-analysis-employee-task-matrix>',
          isReact: true,
        })
        .state('assignmentAnalysis.employeeCapacityReport', {
          url: '/employee-capacity-report',
          template:
            '<assignment-analysis-employee-capacity-report></assignment-analysis-employee-capacity-report>',
          isReact: true,
        })
        .state('assignmentAnalysis.deviationOverview', {
          url: '/deviationoverview',
          template: '<deviation-overview-container></deviation-overview-container>',
          security: 'CapacityPlanning:r',
          isReact: true,
        })
        .state('taskflow.weekplanner', {
          url: '/weekplanner',
          template: '<week-planner-container filters="filters"></week-planner-container>',
          isReact: true,
          controller: [
            '$scope',
            '$stateParams',
            function($scope, $stateParams) {
              $scope.filters = {
                userId: $stateParams.userId,
                executionDateFrom: $stateParams.executionDateFrom,
              };
            },
          ],
          params: {
            userId: null,
            executionDateFrom: null,
          },
        });

      $urlRouterProvider.otherwise('/'); // Default route

      $httpProvider.interceptors.push('authInterceptorSvc');
      $httpProvider.interceptors.push('templateInterceptorSvc');
      $httpProvider.interceptors.push('loadingAnimationInterceptor');

      //Translations
      if (environment === 'local') {
        $translateProvider.useStaticFilesLoader({
          files: [
            {
              prefix: appUrls.api + '/api/translation/',
              suffix: '?all=true',
            },
          ],
        });
      } else {
        $translateProvider.useStaticFilesLoader({
          files: [
            {
              prefix: 'translations/',
              suffix: '.json?b=' + buildversion,
            },
            {
              prefix: appUrls.api + '/api/translation/',
              suffix: '',
            },
          ],
        });
      }

      //Uncomment line below if escape problem occurs again.
      $translateProvider.useSanitizeValueStrategy('escape');

      $translateProvider.useLocalStorage();
      $translateProvider.preferredLanguage('en');
      // I put this in comment because legalForm is sometimes not appearing in section Identification and Maybe the translation has to do with it
      //$translateProvider.directivePriority(1);

      tmhDynamicLocaleProvider.localeLocationPattern(
        'assets/scripts/i18n/angular-locale_{{locale}}.js',
      );
      tmhDynamicLocaleProvider.storageKey('NG_CULTURE_KEY');
      tmhDynamicLocaleProvider.defaultLocale('nl');
      tmhDynamicLocaleProvider.useStorage('$translateLocalStorage');

      //Internation phonenumbers
      ipnConfig.initialCountry = 'be';
      ipnConfig.nationalMode = true;
      ipnConfig.preferredCountries = ['be', 'nl', 'fr', 'lu', 'es'];

      //Datepicker config
      //For formats see https://angular-ui.github.io/bootstrap/#!#dateparser
      uibDatepickerPopupConfig.altInputFormats = [
        'd!/M!/yyyy',
        'd!/M!/yy',
        'd!-M!-yyyy',
        'd!-M!-yy',
        'yyyy/M!/d!',
        'yyyy-M!-d!',
      ];
      //Set default format
      uibDatepickerPopupConfig.datepickerPopup = 'd!/M!/yyyy';
      //Set minimum date
      uibDatepickerConfig.minDate = new Date(1900, 0, 1);
      uibDatepickerConfig.showWeeks = false;

      //Colorpicker config
      //https://github.com/kaihenzler/angular-minicolors
      angular.extend(minicolorsProvider.defaults, {
        format: 'hex',
        letterCase: 'uppercase',
        defaultValue: '#006B8F',
      });
      //Don't log error if reject is not handled (closing dialogs)
      $qProvider.errorOnUnhandledRejections(false);
    },
  ])
  .run([
    '$window',
    'authService',
    'flySvc',
    '$timeout',
    '$anchorScroll',
    'editableOptions',
    'editableThemes',
    '$state',
    '$transitions',
    '$rootScope',
    'appInsights',
    '$translate',
    '$http',
    'optionsSvc',
    'checkSecurity',
    'checkFeature',
    '$location',
    function(
      $window,
      authService,
      flySvc,
      $timeout,
      $anchorScroll,
      editableOptions,
      editableThemes,
      $state,
      $transitions,
      $rootScope,
      appInsights,
      $translate,
      $http,
      optionsSvc,
      checkSecurity,
      checkFeature,
      $location,
    ) {
      //Check if user is logged in
      if (!authService.isLoggedIn()) {
        authService.startAuthentication();
      } else if (appInsights) {
        var profile = authService.getClaims();
        // https://github.com/microsoft/ApplicationInsights-JS/blob/master/API-reference.md
        appInsights.setAuthenticatedUserContext(profile.Sid, profile.GroupSid, true);
      }
      optionsSvc.ready();
      initTranslateService($translate, $timeout);

      SignalRService.startConnection();

      SignalRService.subscribe('showAction', msg =>
        flySvc.action(
          msg.title,
          msg.content,
          msg.action,
          msg.actionLabel,
          msg.actionParameter,
          msg.parameters,
        ),
      );
      SignalRService.subscribe('showProposal', msg =>
        flySvc.proposal(
          msg.title,
          msg.content,
          msg.action,
          msg.actionLabel,
          msg.actionParameter,
          msg.parameters,
        ),
      );
      SignalRService.subscribe('showMessage', msg => flySvc.message(msg.content, msg.parameters));
      SignalRService.subscribe('showError', msg =>
        flySvc.error(msg.content, msg.parameters, msg.fieldId),
      );

      SignalRService.subscribe('showSuccess', msg => flySvc.success(msg.content, msg.parameters));

      SignalRService.subscribe('downloadDocument', documentId => {
        DocumentService.download(documentId);
        flySvc.action('msgDocumentReady', 'msgClickHereToDownloadDocument', function() {
          DocumentService.download(documentId);
        });
      });

      SignalRService.subscribe('codaProcessed', function(numberOfTransactions) {
        flySvc.action(
          'msgCODAProcessed',
          '',
          function() {
            $state.go('invoicing.transactions');
          },
          null,
          null,
          {
            n: numberOfTransactions,
          },
        );
        const currentState = $state.$current.name;
        if (currentState === 'invoicing.transactions') {
          $state.reload();
        }
      });

      SignalRService.subscribe('reload', () => window.location.reload(true));
      SignalRService.subscribe('refreshToken', function() {
        authService.signinSilent();
      });

      SignalRService.subscribe('checkinFinished', data => {
        if (data && data.errorCode) {
          flySvc.error(data.errorCode, [], null, data.type);
          return;
        }

        const blobId = typeof data === 'object' ? data.blobId : data;
        if (!!blobId) {
          flySvc.success('msgCheckinSuccesfull');
        } else {
          flySvc.warning('msgCheckinWarning');
        }
      });

      $transitions.onError({}, function(transition) {
        var error = transition.error();
        if (error) {
          //https://ui-router.github.io/ng1/docs/latest/enums/transition.rejecttype.html
          if (error.type === 5 || error.type === 3 || error.type === 2) return;
          if (error.detail && error.detail === 'Not Authorized') {
            flySvc.error(4003, []); //Unauth error
            const $state = transition.router.stateService;
            return $state.go('home', {}, { reload: true });
          }
          if (error.detail && error.detail.data) error = error.detail.data;
          if (error.data) error = error.data;
          if (error.code && typeof error.parameters !== 'undefined')
            flySvc.error(error.code, error.parameters);
          else if (error.message) flySvc.error('StateChangeError:' + error.message);
          else flySvc.error('StateChangeError:' + error);
          console.error('StateChangeError: ' + error);
        } else flySvc.error('StateChangeError');
      });

      $transitions.onStart({}, function(transition) {
        if (!authService.isLoggedIn()) authService.startAuthentication();

        angular.forEach($http.pendingRequests, function(request) {
          if (request.cancel && request.timeout) {
            request.cancel.resolve();
          }
        });

        const $state = transition.router.stateService;
        const toStateConfig = transition.to();
        if (toStateConfig.security && !checkSecurity(toStateConfig.security)) {
          flySvc.error(4003, []); //Unauth error
          if (toStateConfig.name !== 'home') return $state.target('home', {}, { reload: true });
          return;
        }
        if (toStateConfig.feature && !checkFeature(toStateConfig.feature)) {
          flySvc.error(4003, []); //Unauth error
          if (toStateConfig.name !== 'home') return $state.target('home', {}, { reload: true });
          return;
        }
        if (!toStateConfig.transformJsonParam) return;
        const { json } = transition.params();
        if (!json || typeof json !== 'object' || Object.keys(json).length === 0) return;

        return $state.target(transition.$to(), json);
      });

      // State-to-title mapping for browser tab titles
      var pageTitles = {
        myProfile: 'My profile',
        'relations.overview': 'Relations',
        'relations.new': 'New relation',
        'relations.compliance': 'Compliance',
        'relations.invoiceschedules': 'InvoiceScheduleOverview',
        'relations.budget': 'BudgetOverview',
        'relations.taskSchedules': 'Task schedule overview',
        'relations.plannedRegistrations': 'PlannedRegistrationOverview',
        'relations.interactions': 'InteractionOverview',
        'relations.audit': 'Relations',
        'registrations.day': 'Registration input',
        'registrations.overview': 'Overview',
        'registrations.settings': 'Pricelist',
        'registrations.pricegrid': 'Pricegrids',
        'invoicing.overview': 'Billing overview',
        'invoicing.draft': 'Draft invoices',
        'invoicing.toInvoice': 'To invoice',
        'invoicing.intraCompany': 'IntraCompanyBilling',
        'invoicing.transactions': 'Transactions',
        'invoicing.invoiceFromScratch': 'New invoice from scratch',
        'invoicing.creditNoteFromScratch': 'New credit note from scratch',
        'taskflow.dashboard': 'Dashboard',
        'taskflow.taskboard': 'Taskboard',
        'taskflow.overview': 'Task overview',
        'taskflow.progressPerEmployee': 'TaskProgressPerEmployee',
        'taskflow.tasklist': 'Task list',
        'taskflow.weekplanner': 'Week planner',
        documents: 'Documents',
        emails: 'Emails',
        interactions: 'InteractionOverview',
        notifications: 'Notifications',
        'hrm.hoursPerEmployee': 'Hours per employee',
        'hrm.absencePerEmployee': 'AbsencePerEmployee',
        'hrm.overview': 'AbsenceCounters',
        'hrm.absenceCalendar': 'AbsenceCalendar',
        'trainings.overview': 'TrainingsManagement',
        'trainings.employeeOverview': 'Trainings',
        'assignmentAnalysis.employeeRelationMatrix': 'AssignmentAnalysisEmployeeRelationMatrix',
        'assignmentAnalysis.employeeTaskMatrix': 'AssignmentAnalysisEmployeeTaskMatrix',
        'assignmentAnalysis.employeeCapacityReport': 'AssignmentAnalysisEmployeeCapacityReport',
        'assignmentAnalysis.deviationOverview': 'Matrix task schedules per relation',
        'reports.registrationsPerRelation': 'Registrations per relation',
        'reports.registrationsPerUser': 'Registrations per user',
        'reports.registrationsPerResourceCategory': 'Registrations per resource category',
        'reports.registrationsPerTaskTemplate': 'Registrations per task template',
        'reports.relationRentability': 'Relation Rentability',
        'reports.performanceBalance': 'Performance balance',
        'reports.invoicingHistory': 'Invoicing history',
        'settings.general': 'General settings',
        'settings.company': 'Own company',
        'settings.license': 'License management',
        'settings.teams': 'Teams',
        'settings.roles': 'TenantRoles',
        'settings.taskTemplates': 'Task templates',
        'settings.workflowConfiguration': 'Workflow configuration',
        'settings.assignmentTemplates': 'Assignment templates',
        'settings.documentTemplates': 'Document templates',
        'settings.invoicetemplates': 'Invoice templates',
        'settings.invoiceText': 'Invoice texts',
        'settings.invoiceSchedules': 'Invoice schedules',
        'settings.folderStructure': 'Document folder structure',
        'settings.tags': 'Tags',
        'settings.interactiontemplates': 'Interaction template settings',
        'settings.reminder': 'Reminder settings',
        'settings.templates.list': 'Settings',
        'settings.templates.new': 'Settings',
        'settings.templates.edit': 'Settings',
        'employees.overview': 'Employees',
        'employees.profiles': 'Price profiles',
        'employees.detail': 'Employees',
        'employees.new': 'Employees',
        'jobs.overview': 'Batch jobs',
        'jobs.detail': 'Batch jobs',
      };

      $transitions.onSuccess({}, function(transition) {
        sendPlausibleAnalyticsPageView(transition);
        const hash = $location.hash();

        // Set scrollbar to top after route change, otherwise it can cause infinite scroll to call
        // API twice because it 'starts' in the middle of the screen
        $anchorScroll(hash || undefined);

        // Update browser tab title (relation detail is handled by RelationFileCtrl)
        var toState = transition.to();
        if (toState.name === 'relations.detail') return;

        if (AuthService.isSupport()) return;

        var titleKey = pageTitles[toState.name];
        if (titleKey) {
          // Still loading translations, wait for it to finish and then init translations
          $translate.onReady().then(function() {
            document.title = $translate.instant(titleKey) + ' - AdminPulse';
          });
        } else {
          document.title = 'AdminPulse';
        }
      });

      //Set default anchorscroll offset
      $anchorScroll.yOffset = function() {
        //Add extra offset when in relation file because it has a sticky header
        const relationFileHeader = document.getElementById('RelationFileHeader');
        if (relationFileHeader) {
          return relationFileHeader.offsetHeight + 61; //51px stick-to-top + 10px extra margin
        }

        return 60;
      };

      //Xeditable Options
      editableOptions.buttons = 'no';
      editableOptions.theme = 'bs3';
      editableOptions.blur = 'submit';
      editableOptions.cancelButtonTitle = $translate.instant('Cancel');
      editableOptions.submitButtonTitle = $translate.instant('Save');
      editableThemes.bs3.inputClass = 'input-sm';

      $rootScope.$on('$translateChangeSuccess', function() {
        editableOptions.cancelButtonTitle = $translate.instant('Cancel');
        editableOptions.submitButtonTitle = $translate.instant('Save');
      });

      //Override default href function for links
      $state.originalHrefFunction = $state.href;
      $state.href = function href(stateOrName, params, options) {
        var result = $state.originalHrefFunction(stateOrName, params, options);
        if (result && result.slice(0, 2) === '#/') {
          return '/' + result; //Add leading slash before hashtag
        } else {
          return result;
        }
      };

      registerPlugin(FilePondPluginFileValidateSize);
      registerPlugin(FilePondPluginFileValidateType); // See: https://pqina.nl/filepond/docs/patterns/plugins/file-validate-type/#properties for attributes
    },
  ]);

function sendPlausibleAnalyticsPageView(transition) {
  let page = transition.router.urlService.path();

  if (page === '/') return;

  const guidPattern = /[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}\/?$/gi;
  const match = page.match(guidPattern);

  if (match) {
    page = page.replace(match[0], '');
  }

  // plausible is not configured on localhost
  if (window.plausible) {
    plausible('pageview', { u: page });
  }
}
